import { SlSocialLinkedin } from 'react-icons/sl';

const data = [
  {
    id: 1,
    icon: <SlSocialLinkedin />,
    link: 'https://www.linkedin.com/in/enes-chatzi-osman-9b38ba19b/',
  },
];

export default data;
